<template>
    <section class="login-register-body-sec" loading="lazy">
        
         <section class="login-form-sec sign-up-wrapper">
            <div class="container">
               <div class="login-form-body">
                <div class="login-logo">
                    <img :src="$siteSettings?.data?.aws_url + $siteSettings?.data?.storage_path.domain_image + $siteSettings?.data?.logo" alt="logo">
                </div>
                  <!-- <div class="login-flow-heading">
                     <h2>{{$t('register', 'REGISTER')}}</h2>
                  </div> -->
                  <!-- <div class="whatsapp-btn" v-if="$siteSettings?.data && $siteSettings?.data?.business_type == 2">
                     <a type="button" class="thm-but" :href="'//wa.me/' + $siteSettings?.data?.social_link?.whatsappno1" target="_blank"
                        v-if="$siteSettings?.data && $siteSettings?.data?.social_link && $siteSettings?.data?.social_link.whatsappno1">
                        <img loading="lazy" src="@/assets/images/whatsApp-icon.webp" alt="whatsapp-icon"> <span class="">{{$t('whatsapp-now', 'Whatsapp Now')}}</span>
                    </a>
                    <div class="v-card__text custom-font">
                        <img src="@/assets/images/depo-wrdl.png" alt="depo-wrdl">
                        <span>{{$t('self-deposit-and', 'Self Deposit and Self Withdrawal method')}} </span>
                    </div>
                     <p class="or-text">{{$t('or-create-account-with-mobile-number', 'OR create account with Mobile Number')}}</p>
                 </div> -->
                  <form action="">
                     <div class="input-field">
                        <div class="input-left">
                           <div class="select-country-code">
                            <select class="form-select w_length_s" v-model="form.code" :disabled="otpSent">
                                <option :value="allowedCountry.phonecode" v-for="(allowedCountry, countryIndex) in $siteSettings.data?.country_code_list" :key="countryIndex">+{{ allowedCountry.phonecode }}</option>
                            </select>    
                           </div>

                           <div class="insert-m-num" >
                              <input type="tel" maxlength="10" :class="{ enabled: !otpSent, disabled: otpSent }"  :disabled="otpSent" @input="form.mobileNo = $helper.sanitizeNumber(form.mobileNo,9999999999);" v-model="form.mobileNo" class="form-control" :placeholder="$t('please-enter-mobile-number', 'Enter Mobile Number') + '*'">
                           </div>
                         </div>
                         <div v-for="(err, index) in checkValidation?.mobile" :key="index">
                            <p class="wrong-message">{{ $t(err.lang, err.error) }}</p>
                        </div>
                        <div v-if="otpBtnInit && form.mobileNo?.length == 10 && !timerRunning && getOTPmsg && !isOtpApiCalled">
                            <p class="wrong-message">{{$t('please-click-on-send-otp','Please Click On Get OTP')}}</p>
                        </div>
                        <div class="int-container-box">
                            <div class="otp-sec">
                                <div class="get-otp-left">
                                    <span>{{ form.mobileNo?.length }}/10</span>
                                </div>
                                <div class="get-otp-right position-relative">
                                    <span class="otp_time" v-if="timerRunning">{{ $t('resend-otp-in', 'Resend OTP In') }} {{ formatTime(minutes) + ":" + formatTime(seconds) }}</span>
                                    <button :disabled=" timerRunning" @click="otpBtnCall()"  :class="{ 'disabled-login': timerRunning }" type="button">
                                        {{ isOtpApiCalled ? '' : resendOtp ? $t('resend-otp',"Resend OTP") : $t('get-otp',"Get OTP") }}
                                    </button>
                                    <div v-if="isOtpApiCalled" class="spinner-border auth_loader" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="int-container-box">
                           <div class="form-container-sec mt-3">
                              <div class="user-password-wrapper">
                                 <div class="icon-box">
                                    <img loading="lazy" src="@/assets/images/key.webp" alt="key">
                                </div>
                                  <div class="password-box">
                                      <input type="text" maxlength="6" @input="form.otp = $helper.sanitizeNumber(form.otp, 999999);" v-model="form.otp" :placeholder="$t('enter-otp', 'Enter OTP')+ '*'" class="form-control">
                                  </div>
                              </div>
                              <div class="error-message-box" v-if="init && checkValidation?.otp?.length > 0">
                                    <p v-for="(err, index) in checkValidation?.otp" :key="index"  class="wrong-message">{{ $t(err.lang, err.error) }}</p>
                                </div>
                          </div>
                        </div>
                     </div>

                     <div class="input-left mt-3" v-if ="!isSetUserId">
                        <div class="user-password-wrapper">
                            <a href="javascript:void(0)" class="text-white text-decoration-underline" @click="isSetUserId =! isSetUserId">
                                {{ $t('set-user-id', 'Want To Set UserID') }}?
                            </a>
                        </div>
                     </div>
                     <div class="input-left mt-3" v-if ="isSetUserId">
                        <div class="user-password-wrapper">
                            <div class="icon-box">
                                <img loading="lazy" src="@/assets/images/user-cmn-icon.png" alt="user-cmn-icon">
                            </div>
                            <div class="password-box">
                                <input type="text"  maxlength="25" minlength="6" required="1" @input="form.userName = $helper.sanitizeDetails('userId', form.userName, 25);" v-model="form.userName"  class="form-control"  :placeholder="$t('enter-user-id', 'Enter User ID')">
                            </div>
                        </div>
                    </div>

                    <div v-if="init && checkValidation?.userId?.length > 0" class="error-message-box">
                        <p v-for="(err, index) in checkValidation?.userId" :key="index" class="wrong-message">{{ $t(err.lang, err.error) }}.</p>
                    </div>

                    <div class="form-container-sec mt-3">
                        <div class="user-password-wrapper">
                           <div class="icon-box">
                              <img loading="lazy" src="@/assets/images/password-icon.webp" alt="password-icon">
                           </div>
                           <div class="password-box">
                              <input  :type="passwordFieldType" @input="form.password = $helper.sanitizeDetails('password', form.password, 20);" maxlength="20" v-model="form.password" :placeholder="$t('enter-password', 'Enter Password')+ '*'" class="form-control">
                              <button class="text-white" type="button" @click="togglePasswordVisibility('password')">
                                <i class="fa-solid" :class="{'fa-eye': passwordFieldType != 'password', 'fa-eye-slash': passwordFieldType == 'password'}"></i>
                              </button>
                           </div>
                        </div>
                        <div class="error-message-box" v-if="init && checkValidation?.password?.length > 0">
                           <p v-for="(err, index) in checkValidation?.password" :key="index"  class="wrong-message">{{ $t(err.lang, err.error) }}</p>
                        </div>
                    </div>

                    <div class="form-container-sec mt-3">
                        <div class="user-password-wrapper">
                           <div class="icon-box">
                              <img loading="lazy" src="@/assets/images/password-icon.webp" alt="password-icon">
                           </div>
                           <div class="password-box">
                              <input :type="confPasswordFieldType" @input="form.confirmPassword = $helper.sanitizeDetails('password', form.confirmPassword, 20);" required="1" maxlength="20" minlength="8"  v-model="form.confirmPassword" :placeholder="$t('enter-confirm-password', 'Enter Confirm Password')+ '*'" class="form-control">
                              <button class="text-white" type="button" @click="togglePasswordVisibility">
                                <i class="fa-solid" :class="{'fa-eye': confPasswordFieldType != 'password', 'fa-eye-slash': confPasswordFieldType == 'password'}"></i>
                            </button>
                           </div>
                        </div>
                        <div class="error-message-box" v-if="init && checkValidation?.confirmPassword?.length > 0">
                           <p v-for="(err, index) in checkValidation?.confirmPassword" :key="index" class="wrong-message">{{ $t(err.lang, err.error) }}</p>
                        </div>
                    </div>

                    <div class="form-container-sec mt-3" v-if ="!isRefral && !hasUrlReferer">
                        <a href="javascript:void(0)" class="text-white text-decoration-underline" @click="isRefral =! isRefral">
                            {{ $t('have-a-refferal-code', 'Have a Referral Code') }}?
                        </a>
                    </div>
                    <div class="form-container-sec mt-3" v-if ="isRefral || hasUrlReferer">
                        <div class="user-password-wrapper">
                           <div class="icon-box">
                              <img loading="lazy" src="@/assets/images/referal-icon.png" alt="referal-icon" class="refer-icon">
                           </div>
                           <div class="password-box">
                              <input type="tel" required="1" v-model="form.referCode" :disabled="hasReferCode"  @input="form.referCode = $helper.sanitizeNumber(form.referCode,999999);" :placeholder="$t('enter-referral-code-optional', 'Referral Code (Optional)')" class="form-control">
                           </div>
                        </div>
                     </div>
                     <div class="login-cmn-btn loader_div">
                        <button type="button" @click="signUpCall()">
                            <template v-if="!loading">
                                {{$t('register', 'Register')}}
                            </template>
                        </button>
                        <div v-if="loading" class="spinner-border auth_loader signUp_loader" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                     </div>

                     <p class="get_id_title">{{$t('get-your-ready-made-id-from-whatsapp', 'Get your ready-made ID from whatsapp')}}</p>

                     <div class="whatsapp-btn" v-if="$siteSettings?.data && $siteSettings?.data?.business_type == 2">
                     <a type="button" class="thm-but" :href="'//wa.me/' + $siteSettings?.data?.social_link?.whatsappno1" target="_blank"
                        v-if="$siteSettings?.data && $siteSettings?.data?.social_link && $siteSettings?.data?.social_link.whatsappno1">
                        <img loading="lazy" src="@/assets/images/whatsApp-icon.webp" alt="whatsapp-icon"> <span class="">{{$t('whatsapp-now', 'Whatsapp Now')}}</span>
                    </a>
                    <!-- <div class="v-card__text custom-font">
                        <img src="@/assets/images/depo-wrdl.png" alt="depo-wrdl">
                        <span>{{$t('self-deposit-and', 'Self Deposit and Self Withdrawal method')}} </span>
                    </div> -->
                     <!-- <p class="or-text">{{$t('or-create-account-with-mobile-number', 'OR create account with Mobile Number')}}</p> -->
                 </div>

                 <!-- <div class="registerWith-container">
                    <div class="registerWith-title">or Login with</div>
                    <div class="registerWith-social">
                        <ul>
                            <li>
                                <a target="_blank" href="https://t.me/bloomberg">
                                    <img src="@/assets/images/telegram.svg" alt="telegram" />
                                </a>
                            </li>
                            <li>
                                <a target="_blank" href="https://www.instagram.com/reliancejio/?hl=en">
                                    <img src="@/assets/images/instagram.svg" alt="instagram" />
                                </a>
                            </li>
                            <li>
                                <a target="_blank" href="https://www.facebook.com/AdaniOnline/">
                                    <img src="@/assets/images/facebook.svg" alt="facebook" />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div> -->

                     <div class="acc-and-join-sec">
                        <span>{{$t('already-have-an-account', 'Already have an Account')}} ? </span>
                        <span><router-link :to="{ name: 'login' }">{{$t('login', 'Login')}}</router-link></span>
                     </div>
                  </form>
               </div>
            </div>
         </section>
      </section>
</template>
<script>
import commonAuth from '../services/commonAuth';
import validate from '../services/authValidation';
export default {
    name: 'SignUp',
    extends: commonAuth,
    data() {
        return {
            form: {
                code: this.$siteSettings.data && this.$siteSettings.data.cncode ? this.$siteSettings.data.cncode : "91",
                mobileNo: "",
                otp: [],
                userName: "",
                password: "",
                confirmPassword: "",
                referCode: this.getQueryParam("refer_code", window.location.href),
            },
            phnInit: false,
            loading: false,
            otpBtnInit:false,
            isRefral:false,
            hasUrlReferer: false,
            isSetUserId: this.getQueryParam("refer_code", window.location.href) ? true : false
        };
    },
    computed: {
        checkValidation() {
            const validationErrors = validate.areFieldsValid(
                'signup',
                this.form.mobileNo, 
                this.form.otp, 
                this.form.userName, 
                this.form.password,
                this.form.confirmPassword
            );
            if(this.init || this.phnInit){
                return validationErrors;
            }
        },
        hasReferCode() {
            return (window.location.href).includes('refer_code');
        },
    },
    created(){
        if((window.location.href).includes('refer_code')) {
            this.hasUrlReferer = true;
        }
    },
    methods: {
        signUpCall() {
            if(!this.isOtpApiCalled) {
                this.getOTPmsg = true;
            }
            this.phnInit = true;
            this.otpBtnInit = true;
            if (!this.otpSent){ 
                return
            } else {
                this.init = true;
                if(Object.keys(this.checkValidation).length === 0) {
                    this.signUpServiceCall();
                }
            }
        },
        otpBtnCall(){
            this.getOTPmsg = true;
            this.phnInit=true;
            this.otpBtnInit=true;
            this.sendOtpCall();
        },
        signUpServiceCall() {
            this.loading = true;
            let isDownLine = this.getQueryParam("downline", window.location.href);
            let data = {
                "userid": this.form.userName,
                "phone": this.form.mobileNo,
                "password": this.form.password,
                "otp": this.getOtp(),
                "isDownLine": isDownLine ? isDownLine : false,
                "refer_code": this.form.referCode,
                "cncode": this.form.code,
            };
            this.$apiCall('post', 'REGISTER', data).then(response => {
                if (response) {
                    this.loading = false;
                    if (response.status == 200) {
                        if (response.data.status == 0) {
                            this.$errorToast(response.data.debug[0]);
                        } else {
                            this.$successToast(response.data.message);
                            this.refreshData();
                            this.$helper.showLogin();                        
                        }
                    }
                }
            }).catch(error => {
                if (error)
                    this.loading = false;
                    this.$errorToast(error[0]);
            });
        },
        getQueryParam(paramName, url) {
            if (!url) url = location.href;
            paramName = paramName.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
            var regexS = "[\\?&]" + paramName + "=([^&#]*)";
            var regex = new RegExp(regexS);
            var results = regex.exec(url);
            return results == null ? null : results[1];
        }
    },
};


</script>


<style scoped>
.refer-code.form-control:disabled {
    background-color: #565859 !important;
}
.select-country-code .form-select {
	border: 1px solid #999898 !important;
}
.select-country-code .form-select {
    background-image:url('@/assets/images/country-code-dd-icon.png') !important; 
}

.cn-disabled-btn {
    opacity: 0.5;
}

.cn-code .dropdown-item:focus {
    background-color: transparent !important;
    color: #ffffff !important;
}

li {
    list-style-type: none;
}

.form-control:disabled {
    background: transparent;
    opacity: 0.6;
}
</style>